import { useTranslation } from 'next-i18next/pages';

import { CareType } from '@pflegia/types/api/employer/care-type';

import { careTypeToTypeOfEmployer } from '@shared/application/care-type-to-type-of-employer';

import { CareTypeIcon } from '../care-type-icon/CareTypeIcon';
import { employerTypeTitle } from '../position-card/employer-type-mappings';

interface CareTypeProps {
  type: CareType;
}

const CareTypeWithIcon: React.FC<CareTypeProps> = ({ type }) => {
  const { t } = useTranslation('candidateFields', { keyPrefix: 'typeOfEmployer' });

  return (
    <div className='flex items-center gap-4'>
      <CareTypeIcon type={type} className='size-14 shrink-0' />
      <p className='font-medium'>{t(employerTypeTitle(careTypeToTypeOfEmployer(type)))}</p>
    </div>
  );
};

export default CareTypeWithIcon;
